// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React, { useCallback, useEffect, useState } from 'react';
import BackdropProgress from '../../BackdropProgress';
import CustomSnackbar from '../ui/Snackbars';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from "@material-ui/core/TableHead";
import TableRow from '@mui/material/TableRow';
import useHttp from '../../utils/http';
import "../../css/FundingSources.scss"
import { getFundingSources } from '../../utils/end-points';

const headCells = [
    { id: 'businessUnit', label: 'Business Unit', align: "left", disablePadding: false, },
    { id: 'productUnit', label: 'Product Unit', align: "left", disablePadding: false },
    { id: 'region', label: 'Region', align: "left", disablePadding: false },
    { id: 'subRegion', label: 'Sub Region', align: "left", disablePadding: false },
    { id: 'percentage', label: 'Percentage', align: "right", disablePadding: false }
];


function EnhancedTableHead(props) {

    return (
        <TableHead>
            <TableRow >
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        className='Head-label' >
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

const FundingSources = (props) => {

    const { allocationId } = props
    const { handleRequest } = useHttp()
    const [fundingSources, setFundingSources] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [snackbarData, setSnackbarData] = useState({ open: false, message: "", severity: "", onClose: null })

    useEffect(() => {
        fetchFundingSources(false)
    }, [])

    const fetchFundingSources = useCallback(async () => {
        handleRequest(getFundingSources.replace("$allocationId", allocationId), "GET", null, (fundingSources) => {
            if (fundingSources) {
                setFundingSources(fundingSources)
            }
            else {
                setSnackbarData({ message: "Error while fetching funding sources", open: true, severity: "error", onClose: onCloseSnackbar })
            }
        }, (error) => {
            setSnackbarData({ message: error, open: true, severity: "error", onClose: onCloseSnackbar })
        }, setLoading)
    }, [])

    const onCloseSnackbar = () => {
        setSnackbarData({ ...snackbarData, open: false })
    }

    return (
        <div className='Funding-sources'>
            <CustomSnackbar snackbar={snackbarData} />
            <BackdropProgress open={isLoading} />

            <div>
                <TableContainer className="Table-container">

                    <Table size={'small'}>
                        <EnhancedTableHead headCells={headCells} rowCount={fundingSources.length} />
                        <TableBody >
                            {fundingSources.map((row, key) => {
                                return (
                                    <TableRow hover tabIndex={-1} key={key}>
                                        <TableCell className='Table-cell Table-cell-bu'>{fundingSources[key].businessUnit}</TableCell>
                                        <TableCell className='Table-cell Table-cell-product-unit'>{fundingSources[key].productUnit}</TableCell>
                                        <TableCell className='Table-cell Table-cell-region'>{fundingSources[key].region}</TableCell>
                                        <TableCell className='Table-cell Table-cell-sub-region'>{fundingSources[key].subRegion}</TableCell>
                                        <TableCell className='Table-cell Table-cell-percentage'>{fundingSources[key].percentage}%</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                    {!isLoading && fundingSources.length === 0 && <div className='No-funding-sources-label'>No Funding Sources</div>}
                </TableContainer>
            </div>
        </div>
    );
}

export default FundingSources;